import { Cluster } from 'cluster';
import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('Clusters');

export const updateClusters = actionCreator<Cluster>('CLUSTERS_UPDATE');
export const fetchClustersByIds = actionCreator<number[]>(
  'CLUSTERS_FETCH_BY_IDS'
);



// WEBPACK FOOTER //
// ./src/store/Entities/Clusters/clusters.actions.ts